import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ReactNode, memo } from 'react';
import { GestureResponderHandlers, View } from 'react-native';
import { voiceInputColors } from '../voiceInputColors';

/** What the bar says by default. */
export const kTalkBarLabel = '按住说话 · 点击打字';

/**
 * The composer at rest, as in WeChat: held, it talks; tapped, it opens the
 * text box. Its words are the host's, or a view of its own.
 */
export const TalkBar = memo(
  ({
    label,
    canTalk,
    panHandlers,
  }: {
    label: string | ReactNode;
    canTalk: boolean;
    panHandlers: GestureResponderHandlers;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        {...panHandlers}
        accessibilityRole="button"
        accessibilityLabel={
          typeof label === 'string' ? label : '按住说话，点击打字'
        }
        style={{
          flex: 1,
          height: rpx(44),
          borderRadius: rpx(22),
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: voiceInputColors.input,
        }}
      >
        {typeof label === 'string' ? (
          <Typography.Text
            size={rpx(14)}
            medium
            color={
              canTalk
                ? voiceInputColors.foreground
                : voiceInputColors.mutedForeground
            }
          >
            {label}
          </Typography.Text>
        ) : (
          label
        )}
      </View>
    );
  },
);
